import useSWR from "swr";
import useWebInstance from "grandus-lib/hooks/useWebInstance";

import { Divider } from "antd";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import find from "lodash/find";
import upperFirst from "lodash/upperFirst";
import IsicForm from "components/forms/Isic";

import styles from "./Isic.module.scss";
import { useTranslation } from 'next-i18next';

const Isic = () => {
  const { settings } = useWebInstance();
  const { t } = useTranslation();
  const { data: staticBlocks, isValidating } = useSWR(
    `/api/lib/v1/blocks`,
    (url) => fetch(url).then((r) => r.json()),
    {
      revalidateOnReconnect: false,
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  // if (!toNumber(settings?.isic_active)) {
  //   return null;
  // }

  const cartIsicDescription = get(
    find(staticBlocks, ["hash", "cart_isic_description"]),
    "content",
    ""
  );
  return (
    <div className={styles?.isicWrapper}>
      <Divider style={{ marginTop: "5px" }} />
      <div className={styles?.title}>
        {t("cart:ISIC / ITIC / EURO<26 discount")}
      </div>
      {!isEmpty(cartIsicDescription) ? (
        <div
          dangerouslySetInnerHTML={{ __html: cartIsicDescription }}
          className={styles?.isicDescription}
        />
      ) : (
        <div className={styles?.description}>
          {`${upperFirst(
            t("cart:you can apply your ISIC / ITIC / EURO<26 discount here")
          )}. ${upperFirst(t("cart:just enter your name and card number"))}.`}
          <br />
          <small>
            <i>
              {t(
                "cart:insert card number here in the follwing format: letter + 6 or 12 numbers and letter (if number of your card contains it)"
              )}
            </i>
          </small>
          <br />
          <br />
        </div>
      )}

      <div>
        <IsicForm />
      </div>
    </div>
  );
};

export default Isic;
